import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { TransportOperatorBusRouteService } from 'src/app/angularJS/services/transport-operator-route/transportOperatorRoute.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
  * A Controller used to create operator services
  */
export class TransportOperatorServicesCreateController {
  public static $inject = [
    'ACTToolbarService',
    '$translate',
    '$state',
    'transportOperatorBusRouteService',
    '$rootScope',
    'UserMessages',
    'LinkBuilder',
    'statusConstants',
    'breadcrumbService',
    'operator'
  ];

  public startDate: Date;
  public endDate: Date;
  public aliases: Array<string>;
  public selectedSchemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public transportOperatorService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService;
  private currentLocale: string;

  constructor(
    private toolbarService: ACTToolbarService,
    private $translate: ng.translate.ITranslateService,
    private $state: ng.ui.IStateService,
    private transportOperatorBusRouteService: TransportOperatorBusRouteService,
    private $rootScope,
    private UserMessages: UserMessagesService,
    private linkBuilder: LinkBuilder,
    private statusConstants: InterACT.Interfaces.IStatusConstants,
    private breadcrumbService: BreadcrumbService,
    public operator: InterACT.Interfaces.TransportOperators.TransportOperator
  ) {
    this.activate();
  }

  /**
 * Allows a user to create a transport operator service
 */
  public create = () => {
    this.transportOperatorService.operator = <any>{
      name: this.operator.name[this.currentLocale],
      link: this.linkBuilder.getTransportOperatorsLink(this.operator.id)
    };

    this.transportOperatorService.startDate = <any>(moment(this.startDate).format('YYYY-MM-DD') + 'T00:00:00Z');
    if (this.endDate) {
      this.transportOperatorService.endDate = <any>(moment(this.endDate).format('YYYY-MM-DD') + 'T00:00:00Z');
    }

    this.$rootScope.showSpinner = true;

    if (this.aliases.length > 0) {
      this.transportOperatorService.alias = this.aliases;
    }

    this.transportOperatorService.schemes = [];
    this.selectedSchemes.forEach((scheme) => {
      this.transportOperatorService.schemes.push({
        abbreviation: scheme.reference,
        link: this.linkBuilder.getSchemesLink(scheme.id)
      });
    });

    this.transportOperatorService.status = <any>this.statusConstants.ACTIVE;
    this.transportOperatorService.source = { manualEntry: true };
    this.transportOperatorBusRouteService.create(this.transportOperatorService).then((response: any) => {
      this.completeCreationProcess();
    });
  }

  /**
   * Takes you back to the operators list view
   */
  public goToOperatorServices() {
    this.$state.go('operator.services', { operatorId: this.operator.id }, { reload: 'operator' });
  }

  /**
   * Completes the creation process showing the toast message and redirecting the user back to the operator services list view
   */
  private completeCreationProcess() {
    this.$rootScope.showSpinner = false;
    this.UserMessages.showToast(
      'TOAST_MESSAGE.SERVICE.CREATED',
      { name: this.transportOperatorService.operator.name });
    this.goToOperatorServices();
  }

  /**
   * Sets the toolbars title and loads in a list of schemes associated with the chosen operator
   */
  private activate() {
    this.transportOperatorService = <any>{};
    this.aliases = [];
    this.selectedSchemes = [];
    this.startDate = new Date();
    this.currentLocale = this.$translate.use();

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.OPERATORS',
        sref: 'operators'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.REGISTRATIONS',
        sref: 'operator.services'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.CREATE',
        sref: 'operator.services-create'
      }
    ]);

    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle('HEADING.CREATE_SERVICE', { name: this.operator.name[this.currentLocale] });
    });
  }
}